import styled from "styled-components";

const StyledLoader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 200px;
`;

export default StyledLoader;
